webpackJsonp([53955099886861],{

/***/ 365:
/***/ (function(module, exports) {

	module.exports = {"data":{"markdownRemark":{"html":"<p>The book is wonderful and brought back many memories. We visited many times when it was all being built and then up and running.</p>","frontmatter":{"path":"/content/many-memories","year":"1990-1999","title":"Many memories","image":null,"imagetitle":null,"author":"Emma (Ashley) Shuckburgh","publication":null}}},"pathContext":{}}

/***/ })

});


// WEBPACK FOOTER //
// path---content-many-memories-57220d70dd8463e14bc8.js